import React, { useEffect, useRef, useState } from 'react';
// import moment from 'moment';
import '../../../assets/css/StudentShortDetails.css';
import edit from '../../../assets/icons/editnew.svg';
import Notifier from '../../../Utils/notify'
import { getData, patchData, Postdata, Postdataform } from '../../../API/GlobalApi';
import { WaitExceptionalApprovalModal } from '../../../Component/Modals/WaitFoeExceptionalApprovals';
import { useHasPermission } from '../../../Utils/checkPermissions';
import ConfirmationModal from '../../../Component/Modals/ConfirmationModal'


import { formatAdmitCardDateTime, formatDateDDMMYYYYHHMMSS_UTC, formatDateTime, formatDateTimeSystemRelated, getAdmitCardDate, parseBackendDate, parseBackendDateContest } from '../../../Utils/data&dateTime';
import { generateAdmitCardPdf } from '../../../Utils/generatePdfForTemplateSent';
import { v4 as uuidv4 } from "uuid";
export default function ContextShortDetails({ selectedDetails, currentPage, setRefreshKey }) {

    const hasPermission = useHasPermission();
    const [otp, setOtp] = useState(['', '', '', '']);
    const otpInputs = useRef([]);

    const [otpMode, setOtpMode] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [enteredOTP, setEnteredOTP] = useState("");
    const [loadingOtp, setLoadingOtp] = useState(false);
    const [verifyingOtp, setVerifyingOtp] = useState(false);

    const [aadharValue, setAadharValue] = useState("");
    const [aadharSaving, setAadharSaving] = useState(false);
    const [aadharVerifying, setAadharVerifying] = useState(false);
    const [showVerifyModal, setShowVerifyModal] = useState(false);


    const [editField, setEditField] = useState(null);
    // "aadhar" | "mobile" | null

    const [isEditingAadhar, setIsEditingAadhar] = useState(false);
    const [isEditingMobile, setIsEditingMobile] = useState(false);


    const [mobileValue, setMobileValue] = useState("");
    // const formatAadhar = (value = "") => {
    //     return value.replace(/\D/g, "").match(/.{1,4}/g)?.join(" ") || "";
    // };

    const formatAadhar = (value) => {
        const str = value || ""; // convert null/undefined to empty string
        return str.replace(/\D/g, "").match(/.{1,4}/g)?.join(" ") || "";
    };


    const splitAadhar = (value) => {
        const str = value || "";
        const clean = str.replace(/\D/g, "");
        return [clean.slice(0, 4), clean.slice(4, 8), clean.slice(8, 12)];
    };

    const [aadharParts, setAadharParts] = useState(["", "", ""]);
    const aadharRefs = useRef([]);


    useEffect(() => {
        if (isEditingAadhar) {
            setAadharParts(splitAadhar(aadharValue || selectedDetails?.aadhar));
        }
    }, [isEditingAadhar, aadharValue, selectedDetails?.aadhar]);


    const handleAadharKeyDown = (e, index) => {
        // ⬅ Backspace behavior (existing)
        if (e.key === "Backspace") {
            if (!aadharParts[index] && index > 0) {
                aadharRefs.current[index - 1]?.focus();
            }
        }

        // ⏎ Enter key → Save Aadhaar
        if (e.key === "Enter") {
            const fullAadhar = aadharParts.join("");

            // only trigger on LAST box + full 12 digits
            if (index === 2 && fullAadhar.length === 12 && !aadharSaving) {
                e.preventDefault();
                saveAadhar();
            }
        }
    };

    const handleAadharChange = (e, index) => {
        const val = e.target.value.replace(/\D/g, "").slice(0, 4);

        const updated = [...aadharParts];
        updated[index] = val;
        setAadharParts(updated);

        // auto focus next
        if (val.length === 4 && aadharRefs.current[index + 1]) {
            aadharRefs.current[index + 1].focus();
        }
    };

    const handleOtpChange = (e, index) => {
        const value = e.target.value;

        // Allow only digits
        if (!/^\d?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next input if value entered and not last
        if (value && index < otp.length - 1) {
            otpInputs.current[index + 1].focus();
        }
    };

    const handleOtpKeyDown = (e, index) => {
        // Backspace → move focus to previous if empty
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            otpInputs.current[index - 1].focus();
        }

        // Enter → trigger verify if last input
        if (e.key === "Enter" && index === otp.length - 1) {
            verifyOTP();
        }
    };



    const [verifying, setVerifying] = useState(false);


    const sendOTP = async () => {
        try {


            setLoadingOtp(true);
            setIsEditingMobile(true);
            setOtpMode(true);
            const payload = {

                mobile: isEditingMobile ? mobileValue : selectedDetails.mobile,
            };

            const res = await Postdata('administration/contest-participants/verify-mobile/', payload);
            console.log("response in otp", res);

            if (res?.detail) {
                Notifier.info(res?.detail);
                setOtpSent(true); // only set after success
                setTimeout(() => otpInputs.current[0]?.focus(), 50);

            } else {
                // Generic fallback
                Notifier.error("Failed to send OTP.");
                setOtpMode(false);
            }

            setTimeout(() => {
                otpInputs.current[0]?.focus(); // auto focus first box
            }, 50);
        } catch (error) {
            Notifier.error("Failed to send OTP due to network or server error.");
        } finally {
            setLoadingOtp(false); // stop loader
        }
    };
    const [showIssueConfirmModal, setShowIssueConfirmModal] = useState(false);



    const verifyOTP = async () => {
        const finalOTP = otp.join("");

        if (finalOTP.length !== 4) {
            Notifier.info("Please enter a valid 4-digit OTP");
            return;
        }

        try {
            setVerifying(true);

            const payload = {
                mobile: isEditingMobile ? mobileValue : selectedDetails.mobile,
                otp: finalOTP,
                participant_id: selectedDetails?.id
            };

            const res = await Postdata(
                "administration/contest-participants/verify-mobile/otp/",
                payload
            );

            if (res?.detail?.toLowerCase().includes("success")) {
                Notifier.success(res?.detail);
                setOtpSent(false);
                setOtp(Array(4).fill(""));
                setIsEditingMobile(false);
                setShowIssueConfirmModal(true);
                setRefreshKey(prev => prev + 1)

            } else {
                Notifier.error(res?.error || "OTP verification failed");
            }

        } catch (error) {
            Notifier.error("OTP verification failed");
        } finally {
            setVerifying(false);
        }
    };


    const sendAdmitCardWhatsapp = async (details) => {
        try {
            console.log("details in senditn", details)
            const pdf = await generateAdmitCardPdf(details);

            const fileName = `${details?.arct_roll_number}_${details?.aadhar}.pdf`;
            const pdfBlob = pdf.output("blob");

            const pdfFile = new File(
                [pdfBlob],
                fileName,
                { type: "application/pdf" }
            );

            const formData = new FormData();
            formData.append("document_url", pdfFile);
            formData.append(
                "participant_roll_number",
                details?.arct_roll_number
            );

            const res = await Postdataform(
                "administration/send-admit-card-whatsapp/",
                formData
            );

            if (!res?.success) {
                throw new Error(res?.error || "Failed to send admit card");
            }

            return true;
        } catch (err) {
            console.error(err);
            Notifier.error("Failed to send admit card");
            return false;
        }
    };


    const handleSaveMobile = async () => {
        try {
            if (!mobileValue || mobileValue.length !== 10) {
                Notifier.info("Enter valid mobile number");
                return;
            }
            if (String(selectedDetails?.is_aadhar_verified) !== "true") {
                Notifier.info("Please verify Aadhaar before updating mobile number");
                return;
            }
            setAadharSaving(true);
            const payload = {
                participant_id: selectedDetails?.id,
                mobile: mobileValue,
            };
            const res = await patchData(`administration/contests/2/participants/${selectedDetails.id}/`, payload)

            if (!res?.id) {
                const message = Array.isArray(res?.error)
                    ? res.error.join(", ")
                    : res?.error || "Failed to save mobile number";

                throw new Error(message);
            }

            Notifier.success("Mobile number updated successfully");
            setRefreshKey(prev => prev + 1)
            setIsEditingMobile(false);
            setEditField(null);
            setOtpSent(false);
            setOtpMode(false);

        } catch (err) {

            console.error(err);

            let message = "Something went wrong";

            if (Array.isArray(err?.error) && err.error.length > 0) {
                message = err.error.join(", "); // join multiple errors if any
            } else if (typeof err?.error === "string") {
                message = err.error;
            } else if (err?.message) {
                message = err.message;
            }

            Notifier.error(message);


        } finally {
            setAadharSaving(false);
        }
    };



    useEffect(() => {
        if (!selectedDetails) return;
        setIsEditingAadhar(false);
        setIsEditingMobile(false);
        setOtpSent(false);
        setOtpMode(false);
        setOtp(["", "", "", ""]);
        setAadharValue(selectedDetails.aadhar || "");
        setMobileValue(selectedDetails.mobile || "");
    }, [selectedDetails?.id]);


    const [issuingAdmitCard, setIssuingAdmitCard] = useState(false);
    const isAadharVerified = String(selectedDetails?.is_aadhar_verified) === "true";


    const formatForBackend = (date) => {
        if (!date || isNaN(date.getTime())) return "";
        const pad = (n) => String(n).padStart(2, "0");
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
            `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };



    const handleIssueAdmitCard = async () => {
        if (!selectedDetails) return;
        try {
            const {
                name,
                arct_roll_number,
                contest_name,
                qr_code_id,
                created_at,
                admit_card_issued_at
            } = selectedDetails;

            // const formattedDate = formatDateTime(parseBackendDateContest(admit_card_issued_at));
            const issuedDate =
                parseBackendDateContest(admit_card_issued_at) || new Date();

            const formattedDate = formatAdmitCardDateTime(issuedDate);
            const backendAdmitCardDate = formatForBackend(issuedDate);


            // const admitCardDate = getAdmitCardDate(admit_card_issued_at);
            // const formattedDate = formatDateTimeSystemRelated(admitCardDate);
            // const backendAdmitCardDate = formatForBackend(admitCardDate);
            const printWindow = window.open("", "_blank", "width=400,height=600");
            const qrData = arct_roll_number;

            printWindow.document.write(`
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <title>Admit Card</title>

                        <style>
                            /* PRINT SETTINGS FOR 58MM PRINTER */
                            @media print {
                                @page {
                                    size: 75mm auto;
                                    margin: 0;
                                }
                                body {
                                    margin: 0;
                                    padding: 0;
                                }
                            }

                            body {
                                   width: 70mm;  
                                margin: 0 auto;
                                font-family: monospace;
                                font-size: 11px;
                                line-height: 1.4;
                                text-align: center;
                            }

                            .header {
                                font-size: 14px;
                                font-weight: bold;
                            }

                            .sub-header {
                                font-size: 12px;
                                margin-bottom: 6px;
                            }

                            .divider {
                                border-top: 1px dashed #000;
                                margin: 6px 0;
                            }

                            .row {
                                text-align: left;
                                margin: 4px 0;
                            }

                            .label {
                                font-weight: bold;
                            }

                            .qr img {
                                width: 120px;
                                height: 120px;
                            }

                            .footer {
                                margin-top: 6px;
                                font-size: 10px;
                            }
                        </style>
                    </head>

                    <body>

                        <div class="header">${contest_name}</div>
                        <div class="sub-header">Admit Card</div>

                        <div class="divider"></div>

                        <div class="qr">
                            <img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${qrData}" />
                        </div>

                        <div class="divider"></div>

                        <div class="row">
                            <span class="label">Candidate:</span> ${name}
                        </div>

                        <div class="row">
                            <span class="label">Form No:</span> ${arct_roll_number}
                        </div>

                        <div class="row">
                            <span class="label">Date Time:</span> ${formattedDate}
                        </div>

                        <div class="divider"></div>

                        <div class="footer">
                            Please carry this slip to the exam hall
                        </div>

                        <script>
                            window.onload = function () {
                                window.print();
                                setTimeout(() => window.close(), 300);
                            };
                        </script>

                    </body>
                    </html>
                 `);

            printWindow.document.close();

            // const pdf = await generateAdmitCardPdf(selectedDetails);
            const pdf = await generateAdmitCardPdf({
                ...selectedDetails,
                admit_card_issued_at: backendAdmitCardDate
            });

            const uniqueFileName = uuidv4().replace(/-/g, "").slice(0, 20);
            const fileName = `${selectedDetails?.arct_roll_number}_${selectedDetails?.aadhar}.pdf`;

            if (selectedDetails?.status.toLowerCase() !== "complete") {

                const pdfBlob = pdf.output("blob");
                const pdfFile = new File(
                    [pdfBlob],
                    fileName,
                    { type: "application/pdf" }
                );

                const formData = new FormData();
                formData.append("document_url", pdfFile);
                formData.append("participant_roll_number", selectedDetails?.arct_roll_number);
                formData.append("admit_card_issued_at", backendAdmitCardDate);
                const res = await Postdataform("administration/send-admit-card-whatsapp/", formData);
                // fire & forget API call
                // Postdataform("administration/send-admit-card-whatsapp/", formData)
                //     .catch(err => {
                //         console.error(err);
                //         // Notifier.error("Failed to send admit card on WhatsApp");
                //     });
                setRefreshKey(prev => prev + 1)
                if (res?.success) {
                    // setRefreshKey(prev => prev + 1)
                } else {
                    Notifier.error(res.error || "Failed to issue admit card");
                }

            }
        } catch (error) {
            console.error(error);
            Notifier.error("Failed to issue admit card");
        }
    };



    const handleDownload = async () => {
        if (!selectedDetails) return;
        const pdf = await generateAdmitCardPdf(selectedDetails);
        // Open PDF in new tab
        pdf.output("dataurlnewwindow");
        pdf.save(`AdmitCard_${selectedDetails.arct_roll_number}.pdf`);
    };

    const saveAadhar = async () => {
        try {
            setAadharSaving(true);
            const updatedAadhar = aadharParts.join("");
            const res = await patchData(
                `administration/contests/2/participants/${selectedDetails.id}/`,
                { aadhar: updatedAadhar }
            );
            if (!res) {
                Notifier.error("Aadhaar could not be saved. Please try again in a moment.");
                return;
            }
            if (res?.error) { Notifier.error(res.error[0] || "Failed to save Aadhar"); return; }

            Notifier.success("Aadhar saved successfully");
            setAadharValue(updatedAadhar);
            setIsEditingAadhar(false);
            setRefreshKey(prev => prev + 1)

        } catch (err) {
            console.error(err);
            Notifier.error("Failed to save Aadhar");
        } finally {
            setAadharSaving(false);
        }
    };


    const verifyAadhar = async () => {
        try {
            setAadharVerifying(true);
            const updatedAadhar = aadharParts.join("");

            const res = await getData(
                `administration/contest-verify-aadhar/?contest_id=2&participant_id=${selectedDetails.id}`,
                { aadhar: updatedAadhar }
            );
            if (res?.detail) {
                Notifier.success(res.detail);
                setRefreshKey(prev => prev + 1)
                return true; // indicate success
            } else if (res?.error) {
                Notifier.error(res.error[0] || "Failed to verify Aadhar");
                return false; // indicate failure
            }

            // fallback
            Notifier.error("Failed to verify Aadhar");
            return false;

        } catch (err) {
            console.error(err);
            Notifier.error("Aadhar verification failed");
            return false;
        } finally {
            setAadharVerifying(false);
        }
    };


    if (!selectedDetails) return null;


    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <p style={{ background: '#F9F9F9', padding: '16px', borderRadius: '8px', textAlign: 'left', fontWeight: 500, color: "#222F3E", display: 'flex', justifyContent: 'space-between' }}>Contest Participants's SHORT DETAILS:
                    </p>
                </div>
            </div>
              <div style={{
                flex: 1,
                overflowY: "auto",
                overflowX: "hidden",
                minHeight: 0  ,         // ← critical for flex scroll
                 paddingBottom: "20px"
            }}> 
            <div className="col-md-12 p-3 stu-pro">
                <div className='stu-pro-inner'>
                    <h4 className='fm-pr-hd' style={{ margin: 0, marginBottom: "10px" }}>{selectedDetails?.name}</h4>
                </div>

                <div>
                    <p className='sd-p'>Contest</p>
                    <p style={{ fontSize: '14px', textAlign: 'left' }}>{selectedDetails?.contest_name}</p>
                </div>
                <div>
                    <p className='sd-p'>Father Name</p>
                    <p style={{ fontSize: '14px', textAlign: 'left' }}>{selectedDetails?.father_name}</p>
                </div>
                <div>
                    <p className='sd-p'>School Name</p>
                    <p style={{ fontSize: '14px', textAlign: 'left' }}>{selectedDetails?.previous_institution}</p>
                </div>
                {selectedDetails?.intermediate_marks && (
                    <div>
                        <p className='sd-p'>Intermidate Marks</p>
                        <p style={{ fontSize: '14px', textAlign: 'left' }}>{selectedDetails?.intermediate_marks}</p>
                    </div>
                )
                }
                <div>
                    <p className='sd-p'>Invigilated By</p>
                    <p style={{ fontSize: '14px', textAlign: 'left' }}>{selectedDetails?.scanned_by ?? '-'}</p>
                </div>
                <div>
                    <p className='sd-p'>Invigilation At</p>
                    <p style={{ fontSize: '14px', textAlign: 'left' }}>{formatDateDDMMYYYYHHMMSS_UTC(selectedDetails?.scanned_at)}</p>
                </div>


                <div className='d-flex flex-column gap-3 mt-3'>
                    <p className="stu-title mt-4">A. Aadhar verification</p>

                    {/* LEFT */}
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{
                            borderRadius: "8px",
                            border: "1px dashed #7F56DA",
                            padding: "12px 10px",
                            background: "#f9fafb",
                        }}
                    >
                        {/* LEFT → Aadhar Label & Number */}
                        <div>
                            <p className="sd-p d-flex justify-content-between">
                                Aadhar Card Number{" "}

                            </p>

                            <div className="d-flex align-items-center gap-2">
                                {!isEditingAadhar ? (
                                    <>
                                        <p className="mb-0">
                                            {selectedDetails?.aadhar ? formatAadhar(selectedDetails.aadhar) : "No Aadhar Number"}
                                        </p>

                                        {/* SHOW + ICON IF NO AADHAR */}
                                        {!selectedDetails?.aadhar ? (
                                            // <img
                                            //     src={plusIcon} // your + icon path
                                            //     style={{ cursor: "pointer", width: "18px" }}
                                            //     onClick={() => {
                                            //         setIsEditingAadhar(true);
                                            //         setAadharParts(["", "", ""]);
                                            //     }}
                                            // />

                                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                                                width="28" height="28" style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    setIsEditingAadhar(true);
                                                    setAadharParts(["", "", ""]);
                                                }}><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle opacity="0.5" cx="12" cy="12" r="10" stroke="#7f56da" stroke-width="1.5"></circle> <path d="M15 12L12 12M12 12L9 12M12 12L12 9M12 12L12 15" stroke="#7f56da" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>

                                            // <svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"
                                            //     onClick={() => {
                                            //         setIsEditingAadhar(true);
                                            //         setAadharParts(["", "", ""]);
                                            //     }}
                                            // ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.25 12.75V18H12.75V12.75H18V11.25H12.75V6H11.25V11.25H6V12.75H11.25Z" fill="#7f56da"></path> </g></svg>
                                        ) : (
                                            !selectedDetails?.is_aadhar_verified && (
                                                <img
                                                    src={edit}
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => {
                                                        setIsEditingAadhar(true);
                                                        setIsEditingMobile(false);
                                                    }}
                                                />
                                            )
                                        )}
                                    </>
                                ) : (
                                    <div style={{ display: "flex", gap: "6px" }}>
                                        {aadharParts.map((part, i) => (
                                            <input
                                                key={i}
                                                ref={(el) => (aadharRefs.current[i] = el)}
                                                value={part}
                                                maxLength={4}
                                                onChange={(e) => handleAadharChange(e, i)}
                                                onKeyDown={(e) => handleAadharKeyDown(e, i)}   // ✅ ADD
                                                className="form-control"
                                                style={{
                                                    width: "60px",
                                                    textAlign: "center",
                                                    fontSize: "13px",
                                                    borderRadius: "6px",
                                                }}
                                            />
                                        ))}
                                    </div>
                                )}

                                {/* SAVE */}
                                {isEditingAadhar && !selectedDetails?.is_aadhar_verified && (
                                    <button
                                        className="add-btn"
                                        onClick={saveAadhar}
                                        style={{
                                            padding: "6px 14px",
                                            fontSize: "12px",
                                            backgroundColor: "#7F56DA",
                                            color: "#fff",
                                        }}
                                    >
                                        {aadharSaving ? <span className="spinner-border spinner-border-sm" role="status" /> : "Save"}
                                    </button>
                                )}

                                {/* EDIT */}
                                {/* {!isEditingAadhar && !selectedDetails?.is_aadhar_verified && (
                                    <img
                                        src={edit}
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            setIsEditingAadhar(true);
                                            setIsEditingMobile(false); // 🔐 safety
                                        }}
                                    />
                                )} */}

                                {/* CANCEL */}
                                {isEditingAadhar && !selectedDetails?.is_aadhar_verified && (
                                    <svg
                                        viewBox="0 0 512 512"
                                        height="18"
                                        width="18"
                                        onClick={() => {
                                            // reset aadhar inputs
                                            setAadharValue(selectedDetails?.aadhar || "");
                                            setAadharParts(splitAadhar(selectedDetails?.aadhar || ""));

                                            // ✅ close ONLY aadhar edit
                                            setIsEditingAadhar(false);
                                        }}
                                        fill="#7F56DA"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <title>Cancel</title>
                                        <g fill="#7F56DA" transform="translate(91.52 91.52)">
                                            <polygon points="
                                            328.96 30.2933333 
                                            298.666667 0 
                                            164.48 134.4 
                                            30.2933333 0 
                                            0 30.2933333 
                                            134.4 164.48 
                                            0 298.666667 
                                            30.2933333 328.96 
                                            164.48 194.56 
                                            298.666667 328.96 
                                            328.96 298.666667 
                                            194.56 164.48
                                        " />
                                        </g>
                                    </svg>
                                )}
                            </div>
                        </div>
                        {selectedDetails?.is_aadhar_verified && (
                            <p
                                className="sd-p"

                                style={{
                                    fontSize: "11px",
                                    padding: "3px 7px",
                                    borderRadius: "999px",
                                    border: "1px solid #bbf7d0",
                                    background: "#dcfce7",
                                    color: "#166534",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    whiteSpace: "nowrap",
                                    width: "fit-content",

                                }}

                            >
                                Completed
                            </p>
                        )}

                        {/* RIGHT → VERIFY BUTTON */}
                        {!selectedDetails?.is_aadhar_verified && (
                            <button
                                className="btn"
                                onClick={() => selectedDetails?.aadhar && setShowVerifyModal(true)}
                                style={{
                                    padding: "6px 14px",
                                    fontSize: "12px",
                                    backgroundColor: selectedDetails?.aadhar ? "#f39c12" : "#ccc", // gray if disabled
                                    color: "#fff",
                                    cursor: selectedDetails?.aadhar ? "pointer" : "not-allowed", // show disabled cursor
                                }}
                                title={selectedDetails?.aadhar ? "Verify Aadhar" : "First add Aadhar"} // tooltip
                                disabled={!selectedDetails?.aadhar} // disable button if no aadhar
                            ><title>{selectedDetails?.aadhar ? "Verify Aadhar" : "First add Aadhar"}</title>
                                {aadharVerifying ? "Verifying..." : "Verify"}
                            </button>
                        )}
                    </div>



                    <p className="stu-title mt-4">B. Authentication</p>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            border: "1px dashed #7F56DA",
                            borderRadius: "8px",
                            padding: "10px 12px",
                            marginBottom: "8px",
                            background: "#f9fafb",
                        }}
                    >
                        {/* LEFT → Contact Label & Input / Number + Edit Icon */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                            <p className="sd-p">Contact : {selectedDetails?.mobile}</p>

                            {/* // <p className="sd-p d-flex">
                            //     <strong>Contact  </strong>{" "}
                            //     {!selectedDetails?.is_mobile_number_unique && (
                            //         <span style={{ color: "red", marginLeft: "8px", fontWeight: 500 }}>
                            //             (Duplicate number)
                            //         </span>
                            //     )} */}
                            {/* <p className="mb-0"> {selectedDetails?.mobile}</p> */}

                            {/* // </p> */}

                            {selectedDetails?.verified ? (
                                <p className="mb-0"> </p>
                            ) : !isEditingMobile ? (
                                // Normal state → number + edit icon side by side
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <p className="mb-0">{selectedDetails?.mobile}</p>
                                    <img
                                        src={edit}
                                        onClick={() => {
                                            setIsEditingMobile(true);
                                            setOtpMode(false); // 🔥 important
                                            setOtpSent(false);
                                        }}
                                        style={{ cursor: "pointer" }}
                                    />
                                </div>
                            ) : otpMode ? (
                                // Input field to edit number
                                <div style={{ display: "flex", gap: "6px" }}>
                                    {otp.map((d, i) => (
                                        <input
                                            key={i}
                                            maxLength={1}
                                            value={d}
                                            onChange={(e) => handleOtpChange(e, i)}
                                            onKeyDown={(e) => handleOtpKeyDown(e, i)}
                                            ref={(el) => (otpInputs.current[i] = el)}
                                            style={{
                                                width: "32px",
                                                height: "32px",
                                                textAlign: "center",
                                                fontSize: "12px",
                                                borderRadius: "6px",
                                                border: "1px solid #ccc",
                                            }}
                                        />
                                    ))}
                                </div>
                            ) : (
                                // OTP inputs
                                <div className="d-flex gap-2 align-items-center">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={mobileValue}
                                        maxLength={10}
                                        style={{
                                            width: "110px",
                                            fontSize: "14px",
                                            padding: "6px 10px",
                                            borderRadius: "6px",
                                            border: "1px solid #ced4da",
                                        }}
                                        onChange={(e) => setMobileValue(e.target.value.replace(/\D/g, ""))}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" && mobileValue.length === 10) {
                                                e.preventDefault();
                                                handleSaveMobile();
                                            }
                                        }}
                                    />


                                    <button
                                        style={{
                                            padding: "6px 14px",
                                            fontSize: "12px",
                                            backgroundColor: isAadharVerified ? "#7F56DA" : "#d1d5db",
                                            color: "#fff",
                                            cursor: isAadharVerified ? "pointer" : "not-allowed",
                                            opacity: isAadharVerified ? 1 : 0.6,
                                        }}
                                        disabled={!isAadharVerified}
                                        title={
                                            isAadharVerified
                                                ? "Save mobile number"
                                                : "Please verify Aadhaar first"
                                        }
                                        onClick={isAadharVerified ? handleSaveMobile : undefined}
                                    >
                                        Save
                                    </button>
                                    <svg
                                        viewBox="0 0 512 512"
                                        height="18"
                                        width="18"
                                        onClick={() => {
                                            setIsEditingMobile(false);
                                            setEditField(null);
                                        }}
                                        fill="#7F56DA"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <title>Cancel</title>
                                        <g fill="#7F56DA" transform="translate(91.52 91.52)">
                                            <polygon points="
                                            328.96 30.2933333 
                                            298.666667 0 
                                            164.48 134.4 
                                            30.2933333 0 
                                            0 30.2933333 
                                            134.4 164.48 
                                            0 298.666667 
                                            30.2933333 328.96 
                                            164.48 194.56 
                                            298.666667 328.96 
                                            328.96 298.666667 
                                            194.56 164.48
                                        " />
                                        </g>
                                    </svg>

                                </div>

                            )}
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",   // 🔥 stack top & bottom
                                alignItems: "flex-end",
                                gap: "6px",
                                marginLeft: "auto",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    marginLeft: "auto", // 🔥 pushes right
                                    flexDirection: otpSent ? "column" : "row", // 🔥 dynamic
                                    alignItems: otpSent ? "flex-end" : "center",
                                }}
                            >
                                {/* <p
                                    className="sd-p"
                                    style={{
                                        fontSize: "11px",
                                        padding: "3px 7px",
                                        borderRadius: "999px",
                                        border: selectedDetails?.verified
                                            ? "1px solid #bbf7d0"
                                            : "1px solid #fecaca",
                                        background: selectedDetails?.verified
                                            ? "#dcfce7"
                                            : "#fee2e2",
                                        color: selectedDetails?.verified
                                            ? "#166534"
                                            : "#991b1b",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        whiteSpace: "nowrap",
                                        width: "fit-content",
                                        cursor: selectedDetails?.verified ? "pointer" : "default",
                                    }}
                                    title={
                                        selectedDetails?.verified
                                            ? "Mobile number is verified"
                                            : "Mobile number verification pending"
                                    }
                                >
                                    {selectedDetails?.verified ? "Completed" : "Pending"}
                                </p> */}


                                {/* RIGHT → Action Icons / Buttons */}

                                {/* {!selectedDetails?.verified && (
                                    !otpSent ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="30" height="30" fill="#7F56DA" style={{
                                            cursor: selectedDetails?.is_aadhar_verified ? 'pointer' : 'default',
                                            alignSelf: 'end'
                                        }}
                                            onClick={selectedDetails?.is_aadhar_verified ? sendOTP : undefined}
                                            title={selectedDetails?.is_aadhar_verified ? 'Click to send OTP' : 'Aadhar should be verified'}
                                        > <title>{selectedDetails?.is_aadhar_verified ? 'Click to send OTP' : 'Aadhar should be verified'}</title> <path d="M458.5 112H265V62.4A31.4 31.4 0 0 0 233.6 31H62.4A31.4 31.4 0 0 0 31 62.4v387.2A31.4 31.4 0 0 0 62.4 481h171.2A31.4 31.4 0 0 0 265 449.6V292h193.5A22.5 22.5 0 0 0 481 269.5V134.5A22.5 22.5 0 0 0 458.5 112ZM125.5 50.1h45a11.3 11.3 0 0 1 0 22.5h-45a11.3 11.3 0 0 1 0-22.5Zm45 411.8h-45a11.3 11.3 0 1 1 0-22.5h45a11.3 11.3 0 0 1 0 22.5Zm74.7-41.6H50.8V91.8h194.4V112H125.3a22.3 22.3 0 0 0-22.3 22.3V269.7a22.3 22.3 0 0 0 22.3 22.3H166v36.1a11.1 11.1 0 0 0 19 7.9L229 292h16.2ZM220.8 210.2a11.3 11.3 0 0 1-11.3 19.5L195.3 221.4V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4L161.5 202l-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM328.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM436.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3Z" /> </svg>

                                    ) : (
                                        <div className="d-flex gap-2 align-self-end">
                                            <button
                                                style={{
                                                    padding: "6px 14px",
                                                    fontSize: "12px",
                                                    backgroundColor: "#f39c12",
                                                    color: "#fff",
                                                }}
                                                onClick={sendOTP}
                                            >
                                                Resend OTP
                                            </button>
                                            <button
                                                style={{
                                                    padding: "6px 14px",
                                                    fontSize: "12px",
                                                    backgroundColor: "#7F56DA",
                                                    color: "#fff",
                                                }}
                                                onClick={verifyOTP}
                                            >
                                                Verify
                                            </button>
                                        </div>
                                    )
                                )} */}

                            </div>
                        </div>
                    </div>
                    {String(selectedDetails?.is_aadhar_verified) === "true" &&
                        // String(selectedDetails?.verified) === "true" &&
                        // selectedDetails?.status?.toLowerCase() !== "complete" && 
                        (
                            <div className="d-flex justify-content-end">
                                <button className="add-btn" onClick={handleIssueAdmitCard}>
                                    {String(selectedDetails?.status).toLowerCase() === "complete"
                                        ? "Print Admit Card"
                                        : "Issue Admit Card"}
                                </button>
                                {/* <button className="add-btn" onClick={handleDownload}>Download Admit Card</button> */}
                                {/* generateAdmitCardPdf */}
                            </div>
                        )}
                </div>
            </div>
            </div>







            <ConfirmationModal
                isOpen={showVerifyModal}
                title="Verify Aadhar"
                message={`Do you want to verify ${selectedDetails?.name}'s Aadhar number ${(aadharValue || selectedDetails?.aadhar)
                    ? `XXXX-XXXX-${(aadharValue || selectedDetails?.aadhar).slice(-4)}`
                    : "-"}?`}
                triggerOnEnter={true}
                isSubmitting={verifying}
                onCancel={() => setShowVerifyModal(false)}
                onConfirm={async () => {
                    try {
                        setVerifying(true);

                        const success = await verifyAadhar(); // 🔥 your API call

                        if (success) {
                            setShowVerifyModal(false); // only close if success
                        }
                    } finally {
                        setVerifying(false);
                    }
                }}
            />

            <ConfirmationModal
                isOpen={showIssueConfirmModal}
                title="Issue Admit Card"
                message="Mobile number verified successfully. Do you want to issue the admit card now?"
                onCancel={() => setShowIssueConfirmModal(false)}
                onConfirm={() => {
                    setShowIssueConfirmModal(false);
                    handleIssueAdmitCard();
                }}
                isSubmitting={issuingAdmitCard}
                triggerOnEnter={true}   // ⭐ ENTER key works here
            />



        </>
    );
}
